import * as React from 'react'
import { SVGProps } from 'react'
const SvgHouse2 = (props: SVGProps<SVGSVGElement>) => (
  <svg width={11} height={12} viewBox="0 0 11 12" fill="none" {...props}>
    <path
      d="M1.1 10.934h2.454v-4.22h3.892v4.22H9.9V4.542l-4.4-3.21-4.4 3.21v6.393ZM0 12V4.01L5.5 0 11 4.01V12H6.346V7.78H4.654V12H0Z"
      fill="#000"
    />
  </svg>
)
export default SvgHouse2
